/**
 * GB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { GbGeschaeftId } from './gbGeschaeftId';
import { GrundbuchamtListEntryMeta } from './grundbuchamtListEntryMeta';
import { GrundstueckId } from './grundstueckId';
import { PersonStammMasterListEntryMeta } from './personStammMasterListEntryMeta';
import { TimePointListEntryMeta } from './timePointListEntryMeta';


export interface GrundbuchgeschaeftRestDetailEntryMeta { 
    anmelderId?: Array<string>;
    mAnmelderId?: FieldMetaData;
    timePoint?: TimePointListEntryMeta;
    mTimePoint?: FieldMetaData;
    eingangTagebuch?: Date;
    mEingangTagebuch?: FieldMetaData;
    eCH0134GeneriertAm?: Date;
    mECH0134GeneriertAm?: FieldMetaData;
    anmelder?: Array<PersonStammMasterListEntryMeta>;
    mAnmelder?: FieldMetaData;
    ausgangTagebuch?: string;
    mAusgangTagebuch?: FieldMetaData;
    anmelderText?: string;
    mAnmelderText?: FieldMetaData;
    status?: GrundbuchgeschaeftRestDetailEntryMeta.StatusEnum;
    mStatus?: FieldMetaData;
    registraturText?: string;
    mRegistraturText?: FieldMetaData;
    grundstueckIds?: Array<GrundstueckId>;
    mGrundstueckIds?: FieldMetaData;
    egbtbid?: string;
    mEgbtbid?: FieldMetaData;
    beschreibung?: string;
    mBeschreibung?: FieldMetaData;
    zeitpunktRechtsgueltig?: Date;
    mZeitpunktRechtsgueltig?: FieldMetaData;
    meldungsrelevant?: GrundbuchgeschaeftRestDetailEntryMeta.MeldungsrelevantEnum;
    mMeldungsrelevant?: FieldMetaData;
    grundbuchmeldungPDFpossible?: boolean;
    mGrundbuchmeldungPDFpossible?: FieldMetaData;
    grundbuchmeldungRTFpossible?: boolean;
    mGrundbuchmeldungRTFpossible?: FieldMetaData;
    gbAmt?: GrundbuchamtListEntryMeta;
    mGbAmt?: FieldMetaData;
    id?: GbGeschaeftId;
    mId?: FieldMetaData;
}
export namespace GrundbuchgeschaeftRestDetailEntryMeta {
    export type StatusEnum = 'TAGEBUCH' | 'TAGEBUCH_ABGESCHLOSSEN' | 'VORPRUEFUNG' | 'BEREIT_FUER_GRUNDBUCH' | 'HAUPTBUCH' | 'HAUPTBUCH_ABGESCHLOSSEN' | 'VERIFIKATION' | 'RECHTSGUELTIG' | 'RECHTSGUELTIG_AUSGETRAGEN' | 'SUSPENDIERT' | 'EXMATRIKULIERT' | 'PROVISORISCH_ABGEWIESEN' | 'REKURS' | 'REKURS_AKZEPTIERT' | 'ABGEWIESEN' | 'ABGEWIESEN_AUSGETRAGEN' | 'ZURUECKGEZOGEN' | 'ZURUECKGEZOGEN_AUSGETRAGEN';
    export const StatusEnum = {
        TAGEBUCH: 'TAGEBUCH' as StatusEnum,
        TAGEBUCH_ABGESCHLOSSEN: 'TAGEBUCH_ABGESCHLOSSEN' as StatusEnum,
        VORPRUEFUNG: 'VORPRUEFUNG' as StatusEnum,
        BEREIT_FUER_GRUNDBUCH: 'BEREIT_FUER_GRUNDBUCH' as StatusEnum,
        HAUPTBUCH: 'HAUPTBUCH' as StatusEnum,
        HAUPTBUCH_ABGESCHLOSSEN: 'HAUPTBUCH_ABGESCHLOSSEN' as StatusEnum,
        VERIFIKATION: 'VERIFIKATION' as StatusEnum,
        RECHTSGUELTIG: 'RECHTSGUELTIG' as StatusEnum,
        RECHTSGUELTIG_AUSGETRAGEN: 'RECHTSGUELTIG_AUSGETRAGEN' as StatusEnum,
        SUSPENDIERT: 'SUSPENDIERT' as StatusEnum,
        EXMATRIKULIERT: 'EXMATRIKULIERT' as StatusEnum,
        PROVISORISCH_ABGEWIESEN: 'PROVISORISCH_ABGEWIESEN' as StatusEnum,
        REKURS: 'REKURS' as StatusEnum,
        REKURS_AKZEPTIERT: 'REKURS_AKZEPTIERT' as StatusEnum,
        ABGEWIESEN: 'ABGEWIESEN' as StatusEnum,
        ABGEWIESEN_AUSGETRAGEN: 'ABGEWIESEN_AUSGETRAGEN' as StatusEnum,
        ZURUECKGEZOGEN: 'ZURUECKGEZOGEN' as StatusEnum,
        ZURUECKGEZOGEN_AUSGETRAGEN: 'ZURUECKGEZOGEN_AUSGETRAGEN' as StatusEnum
    };
    export type MeldungsrelevantEnum = 'JA' | 'NEIN' | 'UNBEKANNT';
    export const MeldungsrelevantEnum = {
        JA: 'JA' as MeldungsrelevantEnum,
        NEIN: 'NEIN' as MeldungsrelevantEnum,
        UNBEKANNT: 'UNBEKANNT' as MeldungsrelevantEnum
    };
}


